import { ParseError } from "@/repositories/shared/errors/parseError";
import { injectable } from "inversify";
import { err, ok, Result } from "neverthrow";
import {
  HttpNewRouteApplication,
  HttpNewRouteApplicationsResponse,
  INewRouteApplicationParser,
} from "../bbsRepository.types";
import {
  INewRouteApplication,
  INewRouteApplicationsCollection,
} from "@/domain/entities/bbs";

function parseNewRouteApplication(
  data: HttpNewRouteApplication
): INewRouteApplication {
  const address = data.roadAddress?.length
    ? data.roadAddress
    : data.dongAddress ?? "-";
  const detailAddress = data.detailAddress?.length
    ? ` ${data.detailAddress}`
    : "";
  const newRouteApplication: INewRouteApplication = {
    serviceUid: data.serviceUid,
    parentUid: data.parentUid,
    memberUid: data.memberUid,
    memberName: data.memberName,
    title: `${address}${detailAddress}`,
    displayYn: data.displayYn,
    receiverCount: data.receiverCount,
    talkTypeCode: data.talkTypeCode,
    talkTypeName: data.talkTypeName,
    uid: data.uid,
    statusCode: data.statusCode,
    statusName: data.statusName,
    campusCode: data.campusCode,
    campusName: data.campusName,
    workTimeCode: data.workTimeCode,
    workTimeName: data.workTimeName,
    roadAddress: data.roadAddress,
    dongAddress: data.dongAddress,
    detailAddress: data.detailAddress,
    useBeginDtm: data.useBeginDtm,
    useEndDtm: data.useEndDtm,
    createdTs: data.createdTs,
    savedTs: data.savedTs,
  };
  return newRouteApplication;
}

@injectable()
export class NewRouteApplicationParser implements INewRouteApplicationParser {
  constructor() {}

  toDomain(
    response: HttpNewRouteApplicationsResponse
  ): Result<INewRouteApplicationsCollection, ParseError> {
    try {
      const totalCount = response.totalCount;
      const newRouteApplications = response.data.map(parseNewRouteApplication);
      const newRouteApplicationsCollection: INewRouteApplicationsCollection = {
        list: newRouteApplications,
        totalCount: totalCount ?? 0,
      };
      return ok(newRouteApplicationsCollection);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
